import { useEffect, useRef, useState } from 'react';
import '../../styles/styles.scss';
import { KTSVG } from 'src/_metronic/helpers/components/KTSVG';

type Props = {
  images?: Array<{
    src: string;
  }>;
};

const Gallery: React.FC<Props> = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentImg = images[currentIndex];
  const thumbnailsContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setCurrentIndex(0);
  }, [images]);

  // seçili thumbnail'i görünür yapmak için
  useEffect(() => {
    const selectedThumbnail = document.querySelector(`[data-index="thumb-${currentIndex}"]`) as HTMLElement;
    if (selectedThumbnail && thumbnailsContainerRef.current) {
      selectedThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, [currentIndex]);

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div className="gallery w-100">
      <div className="position-relative mb-3">
        {/* Main Image */}
        <div className="main-image-container text-center">
          <img className="img-fluid rounded-1 main-image" src={currentImg?.src} alt="" />
        </div>
        
        {/* Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button
              className="position-absolute start-0 top-50 translate-middle-y btn btn-light rounded-pill p-2 px-4"
              onClick={handlePrevious}
              disabled={currentIndex === 0}
              type="button"
            >
              <KTSVG path="/media/icons/duotone/Navigation/Arrow-left.svg" className="svg-icon-2 me-0" />
            </button>

            <button
              className="position-absolute end-0 top-50 translate-middle-y btn btn-light rounded-pill p-2 px-4"
              onClick={handleNext}
              disabled={currentIndex === images.length - 1}
              type="button"
            >
              <KTSVG path="/media/icons/duotone/Navigation/Arrow-right.svg" className="svg-icon-2 me-0" />
            </button>
          </>
        )}
      </div>

      {/* Thumbnail Navigation */}
      <div className="thumbnails-wrapper w-100 overflow-x-auto">
        <div className="thumbnails-container d-flex gap-1" ref={thumbnailsContainerRef}>
          {images.length > 1 && images.map((img, index) => (
            <div
              key={index}
              data-index={`thumb-${index}`}
              className={`thumbnail-item flex-shrink-0 mx-1 cursor-pointer rounded-1 border ${currentIndex === index ? 'border-primary' : ''}`}
              onClick={() => setCurrentIndex(index)}
            >
              <img className="p-1" src={img.src} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
